module.exports = __webpack_public_path__ + "static/media/bg_g.fccdc457.jpg";